export default __webpack_public_path__ + "static/media/rnb-cw.055ec75e.webp";